// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"fe77b3ae","239":"3902dc96","455":"dd1d084c","977":"81114a64"}[chunkId] + ".chunk.js";
};